import { http } from "./http";
import { getPaginationRequestParams } from "../utils/paginationRequest";

// POST /jurisdictions — create jurisdictions for a group, year and a list of municipalities
export function createJurisdiction(payload) {
    return http.post(`v1/jurisdictions`, { ...payload });
}

// GET /jurisdictions — list jurisdictions grouped by group (paginated)
export function getJurisdictions(pagination, searcher) {
    return http.get(`v1/jurisdictions?${getPaginationRequestParams({ ...pagination, ...searcher })}`);
}

// GET /jurisdictions/by-group — get a single group with its municipality ids for a year
export function getJurisdictionByGroupAndYear(groupId, year) {
    return http.get(`v1/jurisdictions/by-group?groupId=${groupId}&year=${year}`);
}

// GET /jurisdictions/selectable-municipalities — comuni of the group's region with a selectable flag
export function getSelectableMunicipalities(groupId, year) {
    return http.get(`v1/jurisdictions/selectable-municipalities?groupId=${groupId}${year ? `&year=${year}` : ""}`);
}

// GET /jurisdictions/:id — get jurisdiction by id
export function getJurisdictionById(id) {
    return http.get(`v1/jurisdictions/${id}`);
}

// PATCH /jurisdictions — connect/disconnect municipalities for a group and year
export function updateJurisdiction(payload) {
    return http.patch(`v1/jurisdictions`, { ...payload });
}

// DELETE /jurisdictions/by-group — delete all the municipalities of a group for a year
export function deleteJurisdictionByGroupAndYear(groupId, year) {
    return http.delete(`v1/jurisdictions/by-group?groupId=${groupId}&year=${year}`);
}

// POST /jurisdictions/reassign-memberships — re-scope active-year memberships from
// previous federations to the federation that now covers each subscriber's comune
export function reassignMemberships(payload) {
    return http.post(`v1/jurisdictions/reassign-memberships`, { ...payload });
}
